import {StatusDTO} from './statusDTO.interface';
import {BaseDTO} from "./_baseDTO.interface";

export interface CustomerGroupDTO extends BaseDTO {
  groupName: string;
}
